import React from 'react';
import { RadarChart, PolarGrid, PolarAngleAxis, Radar, ResponsiveContainer, Tooltip } from 'recharts';

const RadarChartComponent = ({ data }) => {
  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      return (
        <div className="bg-[#1e1e26] border border-[#22222e] rounded-lg px-4 py-2">
          <p className="text-white font-bold" style={{ fontFamily: 'DM Mono, monospace' }}>{payload[0].payload.axis}</p>
          <p className="text-[#ff4500]" style={{ fontFamily: 'DM Mono, monospace' }}>Score: {payload[0].value}/100</p>
        </div>
      );
    }
    return null;
  };

  return (
    <ResponsiveContainer width="100%" height={300}>
      <RadarChart data={data}>
        <PolarGrid stroke="#22222e" />
        <PolarAngleAxis 
          dataKey="axis" 
          stroke="#7b7a88"
          style={{ fontFamily: 'DM Mono, monospace', fontSize: '11px' }}
        />
        <Radar 
          name="Score" 
          dataKey="score" 
          stroke="#ff4500" 
          fill="#ff4500" 
          fillOpacity={0.15}
          strokeWidth={2}
        />
        <Tooltip content={<CustomTooltip />} />
      </RadarChart>
    </ResponsiveContainer>
  );
};

export default RadarChartComponent;
